import Cookies from './Cookies';

export default class CookieBanner {
  constructor() {
    this.banner = document.querySelector('.js-cookie-banner');
    this.banner_close = this.banner.querySelector('.js-cookie-banner-close');
    this.cookie_name = 'js-cookie-banner-closed';
    this.cookies = new Cookies();
    this.cookie_value = this.cookies.getCookie(this.cookie_name);

    if(!this.hasClosed()) {
      this.openBanner();
    }

    this.banner_close.addEventListener('click', (event) => {
      this.cookies.setCookie(this.cookie_name, 'closed', 100);
      this.closeBanner();
    });

  }

  hasClosed() {
    if(this.cookie_value == 'closed') {
      return true;
    }

    return false;
  }

  clearCookie() {
    this.cookies.clearCookie(this.cookie_name);
  }

  closeBanner() {
    this.banner.classList.remove('--active');
  }

  openBanner() {
    this.banner.classList.add('--active');
  }
}
